import { gql } from '@apollo/client';
import AddressSettingsFragment from "../../../fragments/AdressSettings";
import AddressFragment from "../../../fragments/Address";

const GET_COMPANY_ADDRESS_FIELD_SETTINGS_AND_VALUES = gql`
  query getCompanyAddressFieldSettingsAndValues($companyId: Int!) {
    companyAdminContext {
      addressSettings {
        getCompanyAddressFieldSettingsAndValues(companyId: $companyId) {

          companyId

          deliveryAddressSettings {
            ...AddressSettingsFields
          }
          invoiceAddressSettings {
            ...AddressSettingsFields
          }
          postalAddressSettings {
            ...AddressSettingsFields
          }
          visitingAddressSettings {
            ...AddressSettingsFields
          }

					deliveryAddress{
						...AddressFields
					}
					invoiceAddress{
						...AddressFields
					}
					postalAddress{
						...AddressFields
					}
					visitingAddress{
						...AddressFields
					}

          success
        }
      }
    }
  }
  ${AddressFragment}
  ${AddressSettingsFragment}
`;

export default GET_COMPANY_ADDRESS_FIELD_SETTINGS_AND_VALUES;
